<app-page-body-panel>
  <ng-container ngProjectAs="[pageToolbar]">
    <div class="flex flex-wrap items-center justify-between gap-3">
      @if (showBuiltinToolbar) {
      <app-list-module-toolbar
        [config]="toolbarConfig"
        [filters]="filters"
        [deletedView]="deletedView"
        (filtersChange)="onFiltersChange($event)"
      >
        <ng-content select="[toolbarFiltersExtra]" ngProjectAs="[toolbarFiltersExtra]" />
      </app-list-module-toolbar>
      } @else {
      <ng-content select="[listToolbar]" />
      }

      <div class="flex items-center justify-end gap-2">
        <ng-content select="[toolbarActions]" />
      </div>
    </div>
  </ng-container>

  @if (errorMessage) {
  <div
    class="mb-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800 dark:border-red-900/40 dark:bg-red-950/30 dark:text-red-200"
    role="alert"
  >
    {{ errorMessage }}
  </div>
  }

  <ng-content select="[listTable]" />

  @if (showPagination) {
  <app-list-module-pagination
    [meta]="meta"
    [rowCount]="rowCount"
    [loading]="loading"
    (pageChange)="pageChange.emit($event)"
  />
  }
</app-page-body-panel>
